import { Crosshair, Radio } from "lucide-react";

const ago = (t) => (!t ? "—" : `${Math.max(0, Math.round((Date.now() / 1000 - t) / 60))}m`);
const short = (ca) => (ca ? `${ca.slice(0, 4)}…${ca.slice(-4)}` : "—");

/* PRELAUNCH SNIPER — tickers X / Telegram are talking about before a CA exists; RIPP hunts the mint every tick and buys it the second it lands. */
export const TelegramEars = ({ tg }) => {
  if (!tg) return null;
  const chats = tg.chats || [];
  const tone = !tg.configured ? "text-[var(--r2-red)]" : tg.connected ? "text-[var(--r2-emerald)]" : "text-[var(--r2-text2)]";
  return (
    <div className="rounded-sm border border-[var(--r2-border)] bg-[color-mix(in_srgb,var(--r2-panel)_80%,transparent)] px-3 py-1.5 text-[9px] font-mono" data-testid="telegram-ears">
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5 font-black tracking-[0.18em] text-[var(--r2-cyan)]"><Radio size={11} /> TELEGRAM EARS</span>
        <span className={tone} data-testid="telegram-ears-state">
          {!tg.configured ? "NO BOT TOKEN" : tg.connected ? `LISTENING · @${tg.bot || "bot"}` : tg.enabled === false ? "OFF" : tg.armed === false ? "PAUSED · only the armed MICRO LIVE desk polls the bot" : tg.last_error ? `OFFLINE · ${tg.last_error}` : "CONNECTING…"}
        </span>
        <span className="text-[var(--r2-text2)]" data-testid="telegram-ears-summary">
          <span className="text-[var(--r2-text1)]">{chats.length}</span> rooms · <span className="text-[var(--r2-text1)]">{tg.msgs_today ?? 0}</span> msgs today · <span className="text-[var(--r2-text1)]">{tg.events_today ?? 0}</span> calls into the hive
        </span>
        {chats.length === 0 && tg.configured && (
          <span className="ml-auto text-[var(--r2-text2)]" data-testid="telegram-ears-howto">add @{tg.bot || "the RIPP bot"} to your alpha groups (admin for channels) · BotFather → /setprivacy → Disable</span>
        )}
      </div>
      {(chats.length > 0 || (tg.recent || []).length > 0) && (
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5">
          {chats.map((c) => (
            <span key={c.title} className="text-[var(--r2-text2)]" data-testid={`telegram-chat-${slugify(c.title)}`}>
              <span className="text-[var(--r2-text1)]">{c.title}</span> · {c.msgs} msgs · {c.cas} CAs · {c.tickers} tickers · {ago(c.last_at)} ago
            </span>
          ))}
          {(tg.recent || []).slice(0, 4).map((r, i) => (
            <span key={i} className="text-[var(--r2-text2)] basis-full truncate" data-testid="telegram-recent" title={r.text}>
              <span className="text-[var(--r2-cyan)]">{r.kind}</span> {r.chat}{r.sender ? ` · ${r.sender}` : ""}: {r.tickers.map((t) => `$${t}`).join(" ")} {r.cas.map((c) => short(c)).join(" ")} — {r.text}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const slugify = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

export const PrelaunchStrip = ({ pre, armed }) => {
  if (!pre) return null;
  const hot = pre.hot || []; const res = pre.resolved || [];
  return (
    <div className="rounded-sm border border-[var(--r2-border)] bg-[color-mix(in_srgb,var(--r2-panel)_80%,transparent)] px-3 py-1.5 text-[9px] font-mono" data-testid="prelaunch-strip">
      <div className="flex items-center gap-4">
        <span className="flex items-center gap-1.5 font-black tracking-[0.18em] text-[var(--r2-cyan)]"><Crosshair size={11} /> PRELAUNCH SNIPER</span>
        <span className="text-[var(--r2-text2)]" data-testid="prelaunch-summary">
          <span className="text-[var(--r2-text1)]">{hot.length}</span> tickers hunted · clip <span className="text-[var(--r2-text1)]">{pre.sol_per_buy} SOL</span> · <span className="text-[var(--r2-text1)]">{pre.day?.buys ?? 0}/{pre.max_per_day}</span> sniped today · buys ~{pre.confirm_sec}s after mint once buyers/dev/top-10 confirm · copycats older than {pre.fresh_min}m ignored{pre.confirming ? <> · <span className="text-[var(--r2-amber)]">{pre.confirming} confirming now</span></> : null}
        </span>
        <span className={`ml-auto tracking-[0.15em] ${pre.enabled === false ? "text-[var(--r2-red)]" : armed ? "text-[var(--r2-emerald)]" : "text-[var(--r2-text2)]"}`} data-testid="prelaunch-state">
          {pre.enabled === false ? "OFF" : armed ? "ARMED · BUYS ON CONFIRMED MINT" : "WATCH ONLY · ARM MICRO LIVE"}
        </span>
      </div>
      {(hot.length > 0 || res.length > 0) && (
        <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5">
          {hot.map((r) => (
            <span key={r.ticker} className="text-[var(--r2-text2)]" data-testid={`prelaunch-hot-${r.ticker}`} title={r.first_text || ""}>
              <span className="text-[var(--r2-cyan)] font-semibold">${r.ticker}</span> @{r.first_author || "?"} · {r.events} posts{r.authors > 1 ? ` / ${r.authors} accounts` : ""} · heard {r.since_min}m ago · {r.lookups || 0} lookups
            </span>
          ))}
          {res.map((r) => (
            <span key={r.ca} className={r.bought ? "text-[var(--r2-emerald)]" : r.stage === "CONFIRMING" ? "text-[var(--r2-amber)]" : "text-[var(--r2-text2)]"} data-testid={`prelaunch-resolved-${r.ca}`} title={r.why || r.confirm || ""}>
              <span className="font-semibold">${r.symbol || r.ticker}</span> minted {ago(r.at)} ago → <a href={`https://dexscreener.com/solana/${r.ca}`} target="_blank" rel="noreferrer" className="underline decoration-dotted">{short(r.ca)}</a> · lead {Math.max(0, Math.round((r.lead_sec || 0) / 60))}m · {r.stage === "CONFIRMING" ? `CONFIRMING · ${r.confirm}` : r.bought ? `SNIPED · ${r.confirm || ""}` : `no buy — ${r.why || "pending"}`}
            </span>
          ))}
          {(pre.dropped || []).map((d) => (
            <span key={d.ticker} className="text-[var(--r2-text2)] opacity-70" data-testid={`prelaunch-dropped-${d.ticker}`}>${d.ticker} dropped — {d.why}</span>
          ))}
        </div>
      )}
    </div>
  );
};
